import { render, staticRenderFns } from "./ProdConsBars.vue?vue&type=template&id=d6c7bb40&scoped=true&"
import script from "./ProdConsBars.vue?vue&type=script&lang=js&"
export * from "./ProdConsBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c7bb40",
  null
  
)

export default component.exports